import { DEFAULT_PAGE_SIZE } from '../constants/pagination'
import { ApiResponse, Document } from '../types'
import { apiService } from './api.service'

class TrashService {
  async getTrash(page: number = 1, pageSize: number = DEFAULT_PAGE_SIZE): Promise<ApiResponse<Document>> {
    const response = await apiService.get<ApiResponse<Document>>('trash/', {
      params: { page, page_size: pageSize },
    })
    return response.data
  }

  async emptyTrash(documents?: number[]): Promise<void> {
    const data: any = {
      action: 'empty',
    }

    if (documents && documents.length > 0) {
      data.documents = documents
    }

    await apiService.post('trash/', data)
  }

  async restoreDocuments(documents: number[]): Promise<void> {
    await apiService.post('trash/', {
      action: 'restore',
      documents,
    })
  }

  // Methods for ManagementList compatibility
  async listFiltered(
    page: number,
    _ordering?: string,
    sortField?: string,
    sortReverse?: boolean,
    nameFilter?: string,
    _includeDocumentCount?: boolean,
    extraParams?: any
  ): Promise<ApiResponse<Document>> {
    const params: any = {
      page,
      page_size: extraParams?.page_size ?? DEFAULT_PAGE_SIZE,
    }

    if (sortField) {
      const prefix = sortReverse ? '-' : ''
      params.ordering = `${prefix}${sortField}`
    }

    if (nameFilter) {
      params.title__icontains = nameFilter
    }

    if (extraParams) {
      Object.assign(params, extraParams)
    }

    return this.getTrash(page, params.page_size)
  }

  async delete(document: Document): Promise<void> {
    await this.emptyTrash([document.id])
  }

  // Alias methods for EditDialog compatibility
  async create(_data: Partial<Document>): Promise<Document> {
    throw new Error('Cannot create documents in trash')
  }

  async update(_id: number, _data: Partial<Document>): Promise<Document> {
    throw new Error('Cannot update documents in trash')
  }
}

export const trashService = new TrashService()
